import { formatCurrency } from './currency';

/**
 * Debt amounts are positive and payment amounts are negative in the API.
 * The customer-facing ledger presents the customer's account perspective:
 * debt is negative, while a payment is positive.
 */
export function formatCustomerAccountAmount(amount: number): string {
  const sign = amount > 0 ? '− ' : amount < 0 ? '+ ' : '';
  return `${sign}${formatCurrency(Math.abs(amount))}`;
}

export function customerAccountAmountColor(amount: number): string {
  if (amount > 0) return 'error.main';
  if (amount < 0) return 'success.main';
  return 'text.secondary';
}
